<template>
  <div>
    <el-container>
      <el-header>
        <div style="margin: 10px 0">
          <el-input v-model="serchat" placeholder="请输入客户名称" maxlength="30" style="width: 150px;"></el-input>
          <el-date-picker
            v-model="time"
            type="monthrange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
            :picker-options="pickerOptions">
          </el-date-picker>
          <el-dropdown split-button type="primary" @command="commandEvent">
            <span v-html="dropdownTitle"></span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="全部">全部</el-dropdown-item>
              <el-dropdown-item v-for="(item,index) in dropdownList" :key="index" :command="item.label">{{item.label}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" @click="isAjax" plain>查询</el-button>
          <el-button circle @click="qieFun"><el-image :src="qiehuanIcon" style="width: 20px;height: 20px;vertical-align: middle;"></el-image></el-button>
        </div>
      </el-header>
      <el-main>
        <template>
          <el-table
            :data="tableData"
            show-summary
            :summary-method="getSummaries"
            border
            :height="divHeight"
            style="width: 100%">
            <el-table-column
              fixed
              prop="_id.customerName"
              label="名称"
              width="150">
            </el-table-column>
            <el-table-column
              prop="addedNumber"
              sortable
              label="新增采购商数量"
              :formatter="formatterAmount"
              width="150">
            </el-table-column>
            <el-table-column
              prop="orderNumber"
              sortable
              label="订单总数量"
              :formatter="formatterAmount"
              width="150">
            </el-table-column>
            <el-table-column
              prop="orderSales"
              sortable
              :sort-method="(a, b)=>{return a.orderSales - b.orderSales }"
              label="订单销售额"
              :formatter="formatterAmount"
              width="200">
            </el-table-column>
            <el-table-column
              prop="orderDeal"
              sortable
              :sort-method="(a, b)=>{return a.orderDeal - b.orderDeal }"
              label="订单总成交额"
              :formatter="formatterAmount"
              width="200">
            </el-table-column>
            <el-table-column
              prop="placeNumber"
              sortable
              label="下单采购商数量"
              :formatter="formatterAmount"
              width="150">
            </el-table-column>
            <el-table-column
              prop="ipNumber"
              sortable
              label="访问量"
              :formatter="formatterAmount"
              width="150">
            </el-table-column>
            <el-table-column
              prop="verifySMSNumber"
              sortable
              label="验证短信发送量"
              :formatter="formatterAmount"
              width="150">
            </el-table-column>
            <el-table-column
              prop="marketingSMSNumber"
              sortable
              label="营销短信发送量"
              :formatter="formatterAmount"
              width="150">
            </el-table-column>
            <el-table-column
              prop="marketingMMSNumber"
              sortable
              label="营销彩信发送量"
              :formatter="formatterAmount"
              width="150">
            </el-table-column>
            <el-table-column
              prop="xcxOrderNumber"
              sortable
              label="小程序订单量"
              :formatter="formatterAmount"
              width="120">
            </el-table-column>
            <el-table-column
              prop="wxOrderNumber"
              sortable
              label="微信商城订单量"
              :formatter="formatterAmount"
              width="120">
            </el-table-column>
            <el-table-column
              prop="appOrderNumber"
              sortable
              label="APP订单量"
              :formatter="formatterAmount"
              width="120">
            </el-table-column>
            <el-table-column
              prop="pcOrderNumber"
              sortable
              label="PC订单量"
              :formatter="formatterAmount"
              width="120">
            </el-table-column>
            <el-table-column
              prop="_id.identification"
              label="标识"
              width="80">
            </el-table-column>
            <el-table-column
              prop="dataTime"
              fixed="right"
              label="统计时间"
              width="200">
            </el-table-column>
          </el-table>
        </template>
      </el-main>
      <el-footer>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        qiehuanIcon: require('@/assets/qiehuan.png'),
        numtype: 'NUM',
        pickerOptions: {
          shortcuts: [{
            text: '本月',
            onClick(picker) {
              picker.$emit('pick', [new Date(), new Date()]);
            }
          },{
            text: '今年至今',
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().getFullYear(), 0);
              picker.$emit('pick', [start, end]);
            }
          },{
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 3);
              picker.$emit('pick', [start, end]);
            }
          },{
            text: '最近六个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 6);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        serchat:"",
        time:[
          new Date(),
          new Date()
        ],
        dropdownTitle:"请选择",
        tableData:[],
        divHeight:500,
        dropdownList:[],
        orderNumber:[],
        orderSales:[],
        orderDeal:[],
        placeNumber:[],
        ipNumber:[],
        addedNumber:[],
        dataTime:[],
        gDataList:[],
      }
    },
    methods:{
      formatterAmount(row, column, cellValue) {
        if (cellValue) {
          cellValue = parseFloat(cellValue).toFixed(2)
          cellValue = parseFloat(cellValue)
          if (this.$store.getters.getStoreNumtype === 'CN') {
            if (parseFloat(cellValue) > 9999) {
              const units = ['', '万', '亿', '十亿', '百亿', '千亿'];
              let num = Math.abs(cellValue);
              const uIndex = Math.floor(Math.log10(num) / 4); // 计算所使用的单位
              const result = (cellValue / Math.pow(10, 4 * uIndex)).toFixed(2) + units[uIndex];
              return result;
            } else {
              return cellValue
            }
          } else {
            return cellValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          }
        } else {
          return 0
        }
      },
      formatterAmount1(cellValue) {
        if (cellValue) {
          cellValue = parseFloat(cellValue).toFixed(2)
          cellValue = parseFloat(cellValue)
          if (this.$store.getters.getStoreNumtype === 'CN') {
            const units = ['', '万', '亿', '十亿', '百亿', '千亿'];
            let num = Math.abs(cellValue);
            const uIndex = Math.floor(Math.log10(num) / 4); // 计算所使用的单位
            const result = (cellValue / Math.pow(10, 4 * uIndex)).toFixed(2) + units[uIndex];
            return cellValue <= 0 ? 0 : result;
          } else {
            return cellValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          }
        } else {
          return 0
        }
      },
      formatTime:function(row, column) {
        var date = new Date(row[column.property]);
        var format = "yyyy年MM月dd日";
        var o = {
          "M+" : date.getMonth()+1, //month
          "d+" : date.getDate(),    //day
          "h+" : date.getHours(),   //hour
          "m+" : date.getMinutes(), //minute
          "s+" : date.getSeconds(), //second
          "q+" : Math.floor((date.getMonth()+3)/3),  //quarter
          "S" : date.getMilliseconds() //millisecond
        };
        if(/(y+)/.test(format)) format=format.replace(RegExp.$1,
          (date.getFullYear()+"").substr(4 - RegExp.$1.length));
        for(var k in o)if(new RegExp("("+ k +")").test(format))
          format = format.replace(RegExp.$1,
            RegExp.$1.length==1 ? o[k] :
              ("00"+ o[k]).substr((""+ o[k]).length));
        return format;
      },
      commandEvent(command) {
        this.dropdownTitle = command
      },
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] += '';
          } else {
            sums[index] = 'N/A';
          }
          if (index === 0 || index === 14 || index === 15) {
            sums[index] = 'N/A';
          }else {
            if (sums[index] && sums[index] !== 'N/A') {
              sums[index] = parseFloat(sums[index]).toFixed(2);
              sums[index] = this.formatterAmount1(sums[index])
            } else {
              sums[index] = 0
            }
          }
        });
        return sums;
      },
      addClass:async function(){
        await this.$axios.post('/data/addClass',{
          uid:""
        }).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.dropdownList = response.data[0];
          }else if(response.data.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });
      },
      qieFun: function () {
        this.$store.commit('setStoreNumtype', this.$store.getters.getStoreNumtype === 'NUM' ? 'CN' : 'NUM');
        this.isAjax()
      },
      isAjax:async function(){
        await this.$axios.post('/data/addMonthData',{
          d:this.dropdownTitle,
          s:this.serchat,
          t:this.time
        }).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.tableData = response.data;
            this.divHeight = window.innerHeight-108;
          }else if(response.data.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });
      }
    },
    mounted(){
      this.$store.dispatch('loadData');
      this.addClass();
      this.isAjax();
    }
  }
</script>
<style scoped>
  .el-main{
    overflow: hidden;
    padding: 0 !important;
    margin: 0 !important;
  }
  [v-cloak] {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/views/dataStatistics/monthData.vue